import type { ReactNode } from "react";
import { View } from "@/components/ui";
import { cn } from "@/lib/utils";

import { Typography, type TypographyVariants } from "../typography";

type IconLabelProps = {
  icon: ReactNode;
  label: string;
  variant?: keyof TypographyVariants["variant"];
  className?: string;
  onClick?: () => void;
};

export function IconLabel({
  icon,
  label,
  variant = "label-sm",
  className,
  onClick,
}: IconLabelProps) {
  return (
    <View className={cn("flex flex-col items-center gap-2", className)} onClick={onClick}>
      {icon}
      <Typography variant={variant} align="center">
        {label}
      </Typography>
    </View>
  );
}
